import React from "react";
import SearchInput from "../common/SearchInput/SearchInput";
import { ReactComponent as SearchIcon } from "./../../resources/images/icons/SearchIcon.svg";
import { useLazyGetJobsQuery } from "../../redux/apis/manageJobPostingHooks";
import { handleFilterParamsTypes } from "../../types/custom-types";
import { AUTOSEARCH_SUGGESTION_LENGTH } from "../../constants/Filters";
import { formatDateWithoutTime } from "../../utils";

interface SearchProps {
  params: handleFilterParamsTypes;
  searchValue: string;
  handleSearchChange: (value: string) => void;
  handleSearchSubmit: () => void;
}

const Search: React.FC<SearchProps> = ({
  params,
  searchValue,
  handleSearchChange,
  handleSearchSubmit,
}) => {
  const [triggerGetJobs, { isError, data, isFetching }] = useLazyGetJobsQuery();

  const callSuggestions = (inputValue: string) => {
    let queryParams: { [key: string]: any } = {
      ...AUTOSEARCH_SUGGESTION_LENGTH,
    };

    const newParams = {
      ...params,
      ...AUTOSEARCH_SUGGESTION_LENGTH,
      searchKeyword: inputValue,
    };

    for (const key in newParams) {
      // Check if the value is truthy (not null or empty string)
      if (newParams[key as keyof handleFilterParamsTypes]) {
        // Add the key-value pair to params
        queryParams[key] = newParams[key as keyof handleFilterParamsTypes];
      }
    }

    triggerGetJobs({ ...queryParams });
  };

  return (
    <div className="mjp_section-wrapper search_container">
      <div className="search-heading">Search</div>
      <SearchInput
        placeholder="Search by Job title"
        value={searchValue}
        searchIcon={<SearchIcon />}
        onChange={handleSearchChange}
        size="large"
        suggestions={data?.jobs?.map((job: any) => {return {value:job?.title, extraInfo: formatDateWithoutTime(job?.createDate)}})}
        autoSuggestCallback={callSuggestions} //autoSuggestCallback return input value
        onEnter={handleSearchSubmit}
        onClearCallback={handleSearchSubmit}
        extraInfo={true}
      />
      <div className="search-btn">
        <button
          className="foundit-button secondaryButton medium"
          onClick={handleSearchSubmit}
          disabled={searchValue.length ? false : true}
        >
          Search
        </button>
      </div>
    </div>
  );
};

export default Search;
